import React, { Component } from 'react';
import firebase from 'firebase'
import fire from './fire';
import globals from './globals';
import SanitizedHTML from 'react-sanitized-html';
import TextareaAutosize from 'react-autosize-textarea';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faShareAltSquare, faUnlink } from '@fortawesome/free-solid-svg-icons'
import { faComment, faUser } from '@fortawesome/free-regular-svg-icons'

import HowToUse from './howToUse';


class Writing extends Component {
  static whyDidYouRender = true;

  constructor(props) {
    super(props);
    this.writingLinkInput = React.createRef();
    this.editSentenceField = React.createRef();

    this.state = {
      title: "",
      authors: [],

      writingAuthor: null,

      sentenceMap: {},
      commentMap: {},
      // endSentence: {},

      sentenceFocused: null,
      sentenceText: "",
      startOfParagraph: false,
      commentText: "",
      mode: globals.mode.READ,

      //CARRIED OVER FROM EDITPANE.JS - delete if unused
      initialEditLoad: false,
      // commentText: "",
      // alternatives: null,
    };
    this.loadWriting();
  }


  firestore_sentences(){
    return fire.firestore().collection("writings").doc(this.props.selectedWriting).collection("sentences");
  }

  updateWritingField(field,value){
    let data_map = {};
    data_map[field] = value;
    fire.firestore().collection("writings").doc(this.props.selectedWriting).update(data_map);
  }

  loadWriting(){
    fire.firestore().collection("writings").doc(this.props.selectedWriting).onSnapshot((writing)=>{
      //alert(JSON.stringify(writing.data()));
      this.setState({title: writing.data().title, authors: writing.data().authors});
    });

    // LOAD THE SENTENCES FROM THE DB
    let firestore_sentences = this.firestore_sentences();
    firestore_sentences.onSnapshot((sentenceCollection) => {
        let data_map = {};
        console.log(sentenceCollection);
        sentenceCollection.docs.forEach( (sent) => {
          let sent_data = sent.data();
          console.log(sent_data);
          data_map[sent.id] = {id: sent.id, ...sent_data};
          // STORE THE FINAL SENTENCE
          // UNUSED CODE if (!sent.data().next) { this.setState({endSentence: data_map[sent.id]}) }
        });
        this.setState({ sentenceMap: data_map});

        // console.log("sentences map!!");
        // console.log(data_map);

        // Load the comments
        fire.firestore().collection("comments").onSnapshot((commentsCollection) => {
            let data_map = {};
            // console.log(commentsCollection);
            commentsCollection.docs.forEach( (comment) => {
              data_map[comment.id] = {id: comment.id, ...comment.data()};
            });
            // console.log("comments map!!");
            // console.log(data_map);
            this.setState({ commentMap: data_map});
        });

    });
  }

  exitEditPane(){
    this.setState({
      sentenceFocused: null,
      sentenceText: '',
      mode: globals.mode.READ
    });
  }

  //////////////////////////////
  // HANDLERS FOR CHILD ELEMENT
  /////////////////////////////
  handleSentenceTap(sentenceID){
    // If sentence already focused, unfocus:
    if (sentenceID === this.state.sentenceFocused){
      this.exitEditPane();
    } else {
      // If this is not currently focused, focus:
      this.setState({
        sentenceText: this.state.sentenceMap[this.electedAlternative(this.state.sentenceMap[sentenceID].alternatives)].text,
        sentenceFocused: sentenceID,
        startOfParagraph: false,
        mode: globals.mode.CHOOSE,
      });
    }
  }

  handleAddButtonTap(sentenceID,startOfParagraph){
  //alert("you tapped the add button with sentenceID:  " + sentenceID)
    this.setState({
      sentenceText: '',
      sentenceFocused: sentenceID,
      startOfParagraph: startOfParagraph,
      mode: globals.mode.ADD
    }, ()=> {
      if (this.editSentenceField.current) { this.editSentenceField.current.focus(); }
    });
  }

  handleSentenceChange(sentenceText){
    this.setState({sentenceText: sentenceText});
  }

  handleModeChange(mode){
    this.setState({mode: mode});
  }

  addAlternativeSentence(rootSentenceID,commentID,then){
    let firestore_sentences = this.firestore_sentences();
    // let altHash = rootSentence.alternatives; //{9032ujioajdlasd: {'sadsdsada': true}}
    if (rootSentenceID === "TITLE"){ this.updateWritingField("title",this.state.sentenceText);}

    // ALL: PROPOSE AN ALTERNATIVE TO THE MASTER SENTENCE
    let add_data = {
      text: this.state.sentenceText, //update this to be contigent on whether new paragraph or not
      master: rootSentenceID,
      alternatives: {},
      author: this.props.currentAuthor,
    };
    if (commentID){ add_data.comments= firebase.firestore.FieldValue.arrayUnion(commentID); }

    firestore_sentences.add(add_data).then( (docRef) => {

      let altHash = this.altHashWithVote(this.state.sentenceMap[rootSentenceID].alternatives,docRef.id);
      firestore_sentences.doc(rootSentenceID).update ({
        alternatives: altHash
      }).then(()=>{then();});
    });

  };

  handleSubmit(commentID) {
    //event.preventDefault();
    let firestore_sentences = this.firestore_sentences();
    if (this.state.mode === globals.mode.EDIT){
      this.addAlternativeSentence(this.state.sentenceFocused, commentID, ()=>{
        this.exitEditPane();
      });
    } else {
      if (this.state.sentenceFocused === 'FIRST_TITLE'){
        firestore_sentences.doc('TITLE').set( {
          text: '',
          next: null,
          alternatives: {},
          author: this.props.currentAuthor
        }).then( (title_sentence)=>{
          fire.firestore().collection("writings").doc(this.props.selectedWriting).update({title: this.state.sentenceText});
          this.addAlternativeSentence('TITLE', commentID,
            ()=>{
              this.exitEditPane();
            }
          );
        });
      } else {
        // NEW SENTENCE ONLY: CREATE A ROOT SENTENCE
        firestore_sentences.add( {
          text: '',
          next: this.state.sentenceMap[this.state.sentenceFocused].next,
          alternatives: {},
          author: this.props.currentAuthor,
          startOfParagraph: this.state.startOfParagraph,
        }).then( (docRef)=>{
          // tell the previous sentence it has a new one after it.
          firestore_sentences.doc(this.state.sentenceMap[this.state.sentenceFocused].id).update({ next: docRef.id});
          this.addAlternativeSentence(docRef.id, commentID, ()=>{

            this.setState({
              sentenceFocused: this.state.sentenceMap[docRef.id].id,
              sentenceText: "",
              mode: globals.mode.ADD,
              startOfParagraph: false,
            }, () => { this.editSentenceField.current.focus(); });
          });
        });
      }
    }
  }


  setPreference(masterSentence_id, alt_id){

    // HANDLE SPECIAL CASE OF EDITING TITLE:
    if (masterSentence_id === "TITLE" && alt_id){  this.updateWritingField("title",this.state.sentenceMap[alt_id].text);}

    let altHash = this.state.sentenceMap[masterSentence_id].alternatives;
    let newAltHash = this.altHashWithVote(altHash,alt_id);

    this.firestore_sentences().doc(masterSentence_id).update ({
      alternatives: newAltHash
    }).then(function() {
      // Update Local State ?? Seems redundant....
      // let newSentenceMap = Object.assign(this.state.sentenceMap);
      // newSentenceMap[masterSentence_id]["alternatives"] = newAltHash;
      // this.setState({sentenceMap: newSentenceMap});
    })
    .catch(function(error) {
    });
    this.exitEditPane();
  }

  altHashWithVote(altHash,alt_id){
    // Remove current authors vote for other wordings
    Object.keys(altHash).forEach((alt)=>{
      delete altHash[alt][this.props.currentAuthor];
    });
    // Record current authors vote for this wording
    if (alt_id){ //if the alt_id is null/undefined it means that we are trying to delete the alts, not add new ones
      if (!altHash[alt_id]){ altHash[alt_id] = {}; }
      altHash[alt_id][this.props.currentAuthor] =  Date.now();
    }
    return altHash;
  }

  electedAlternative(altHash){
    if (!altHash){ return null; }

    let altVotes;
    let myNumVotes;
    let runningMaxNumVotes = -1;

    let myLatestVote;
    let runningLatestVote = 0;

    let winningAlt = null;

    Object.keys(altHash).some((alt) => {
      altVotes = Object.keys(altHash[alt]);
      myNumVotes = altVotes.length;
      // if this alt has more votes than any we've yet seen
      if (myNumVotes >= runningMaxNumVotes){

        if ( ((myNumVotes > 0) && (runningLatestVote === 0)) || // if this alt has at least one vote and we havent yet recorded any initial latest timestamp of votes, OR
             ((myNumVotes > 0) && (myNumVotes === runningMaxNumVotes)) // this alt has at least one vote and its tied for the max previous seen
           ){
          // THEN its time we see if one of these votes its worthy of record into the latest recorded vote

          let timestamps = altVotes.map((author_key)=>{
            return altHash[alt][author_key];
          });
          myLatestVote = Math.max(timestamps);

          if (myLatestVote < runningLatestVote){ return false; } // break from .some()
          runningLatestVote = myLatestVote;
        }

        winningAlt = alt;
        runningMaxNumVotes = myNumVotes;
      }
    });
    return winningAlt;
  }


  whichBucket(value, max, buckets){
    let valueSize = value / max;
    let bucketSize = 0.51 / (buckets.length); // the alternatives will never have more than 50% of the vote. If they had more, they wouldn't be the alternatives.
    let numBucket = Math.floor(valueSize / bucketSize);
    return buckets[numBucket];
  }


  // DISPLAY SENTENCE HELPER FX
  displaySentence(id,isTitle){

    const sentence = this.state.sentenceMap[id];
    if (!sentence && !isTitle){ return null; }
    let shownSentenceText = '';

    if (sentence){
      let electedAlternative = this.electedAlternative(sentence.alternatives);
      if (electedAlternative){ shownSentenceText = this.state.sentenceMap[electedAlternative].text; }
    }

    let sentenceWrapper =
      "sentence_wrapper " +
      (isTitle ? "writing-title " : "") +
      ((sentence && (this.state.sentenceFocused === sentence.id) && (this.state.mode !== globals.mode.ADD)) ? "sentence_focused " : "");

    let addBtnWrapper =
      "add_btn " +
      ((isTitle && sentence && !sentence.next) ? "add_btn_title add_btn_flashy " : "") +
      ((sentence && (this.state.sentenceFocused === sentence.id) && (this.state.mode === globals.mode.ADD)) ? "sentence_focused " : "");

    let addBtnText;
    if(isTitle && sentence && !sentence.next) {
      addBtnText = "Click here to add your first sentence."
    } else {
      addBtnText = "+";
    }

    if (isTitle && !sentence) {
      return(
        <div>
          <span className="writing-title add_btn_flashy { addBtnWrapper }" onClick={()=>this.handleAddButtonTap('FIRST_TITLE', false)}>
            Click here to add a Title.

          </span>
          { this.editPane('FIRST_TITLE') }
        </div>

      );
    } else {

      let distributionOfVotes = Object.keys(sentence.alternatives).map((alt)=>{return Object.keys(sentence.alternatives[alt]).length});
      let numDissenting = (distributionOfVotes.length > 0) ? distributionOfVotes.reduce((sum, x) => sum + x)-Math.max(...distributionOfVotes) : 0;
      let highlightClass='';

      if (Object.keys(sentence.alternatives).length > 1){
        highlightClass= (numDissenting === 0) ? "highlight0 " : this.whichBucket(numDissenting,this.state.authors.length,["highlight1 ","highlight2 ","highlight3 ","highlight4 "]);
      }

      return (
        <span>
          { sentence.startOfParagraph &&
            <span><br/><br/></span>
          }

          <span key={sentence.id}>
            <span
              className={ highlightClass + sentenceWrapper }
              onClick={()=>this.handleSentenceTap(sentence.id)}
            >
              <SanitizedHTML
                //allowedAttributes={{ 'a': ['href'] }}
                allowedTags={['a','b','i','u','em','strong']}
                html={shownSentenceText}
              />
            </span>

            { this.editPane(sentence.id) }


            <span className={ addBtnWrapper } onClick={()=>this.handleAddButtonTap(sentence.id, false)}>{ addBtnText }</span>

          </span>

          {/* RECURSIVE CALL */}
          { this.displaySentence(sentence.next, false) }

          { !sentence.next && !isTitle &&
            <p>
              <span className={ addBtnWrapper } onClick={()=>this.handleAddButtonTap(sentence.id, true)}>{ addBtnText }</span>
            </p>
          }
        </span>
      );
    }
  }

  root_url(){
    if (window.location.hostname === "localhost" || window.hostname === "127.0.0.1" || window.hostname === ""){
      return "http://localhost:3000/";
    } else {
      return "http://dem-doc.web.app/";
    }
  }

/////// PREVIOUSLY IN EDITPANE.JS
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.handleSentenceChange(value);
  }

  handleCommentChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({commentText: value});
  }

  handleEnter(event){
    if(event.keyCode === 13 && event.shiftKey === false) {
      event.preventDefault();
      event.stopPropagation();

      if (!this.state.commentText){  // if there is no comment, submit without comment
        this.handleSubmit(null);
      } else {
        fire.firestore().collection("comments").add({
          author: firebase.auth().currentUser.uid,
          text: this.state.commentText,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then((docRef)=> {
          this.handleSubmit(docRef.id); // this is the commentID
          this.setState({commentText: ''});
        });
      }

    }
  }

  handleAlternativeSelection(alternative){
    if (alternative === '@@ProposeAlt'){
      if (this.state.mode !== globals.mode.EDIT){ this.handleProposeAlternative(); } // as long as we are not already in this mode
      return;
    }

    this.setPreference(this.state.sentenceFocused, alternative); //STINT

  }

  handleProposeAlternative(){
    this.handleModeChange(globals.mode.EDIT);
    this.setState({initialEditLoad: true}, () => { this.editSentenceField.current.select(); } );
  }

  handleDeleteAlternative(alternative){
    //TODO prob can just look this up in the sentenceMap
    let fireRootSentence = fire.firestore().collection("writings").doc(this.props.selectedWriting).collection("sentences").doc(this.state.sentenceFocused);

    fireRootSentence.get().then((sentenceFocused)=>{
      let sentenceFocusedID = sentenceFocused.id;
      sentenceFocused = sentenceFocused.data();
      if ( (sentenceFocusedID === 'TITLE') && sentenceFocused.next && (Object.keys(sentenceFocused.alternatives).length === 1) ){
        // we can't support the title being deleted with no alt, yet.
        alert("We don't support leaving an active document with no title. If you want to change this title, propose an alternative first.");
        return;
      } else if (Object.keys(sentenceFocused.alternatives).length === 1){
        let next = sentenceFocused.next;

        fireRootSentence.delete().then(()=>{
          fire.firestore().collection("writings").doc(this.props.selectedWriting).collection("sentences").where("next","==",sentenceFocusedID).limit(1).get().then((queryResult)=>{
            queryResult.forEach((prev)=>{
              fire.firestore().collection("writings").doc(this.props.selectedWriting).collection("sentences").doc(prev.id).update({next: next});
            });

          });
        });
      } else {
        fireRootSentence.update({
          ['alternatives.' + alternative]: firebase.firestore.FieldValue.delete()
        });
      }
    });
  }


  currentAuthorsPref(){

    if (!this.state.sentenceFocused || !this.state.sentenceMap[this.state.sentenceFocused].alternatives){ return null; } //STINT could replace with sentenceMap lookup

    let altHash = this.state.sentenceMap[this.state.sentenceFocused].alternatives;
    //console.log("sfa: " + JSON.stringify(altHash));

    for (let alt of Object.keys(altHash)){
      if (altHash[alt][this.props.currentAuthor]){
        //console.log(alt);
        return alt;
      }
    };
  }


  editPane(sentenceID) {
    if (this.state.sentenceFocused !== sentenceID){ return null; }

    if (this.state.mode === globals.mode.ADD){
      return (
        <div class="edit-pane-wrapper">
          <div class="modalRoot" onClick={()=>{this.exitEditPane()}}></div>

          <div className="edit-pane">

            <div className="edit-pane-selection">

              <div id="alternativeSelect">
                <div className="alternativeOption editForm">

                  <form onSubmit={(e)=>this.handleSubmit(e)}>

                    <label>
                      { (this.state.sentenceFocused === 'FIRST_TITLE') && "Add a Title: " }
                      { (this.state.sentenceFocused !== 'FIRST_TITLE') && "Add a Sentence: " }
                    </label>

                    <TextareaAutosize
                      className="sentenceTextInput"
                      name="sentenceText"
                      value={this.state.sentenceText}
                      onChange={(e)=>this.handleInputChange(e)}
                      onKeyDown={(e)=>this.handleEnter(e)}
                      ref={this.editSentenceField}
                    />
                    <label>
                      (Optional) Add a comment to explain why you chose to write this.
                    </label>
                    <TextareaAutosize
                      className="commentTextInput"
                      name="commentText"
                      placeholder="Your comment"
                      value={this.state.commentText}
                      onChange={(e)=>this.handleCommentChange(e)}
                      onKeyDown={(e)=>this.handleEnter(e)}
                    />

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    }


    if ((this.state.mode === globals.mode.CHOOSE) || (this.state.mode === globals.mode.EDIT)){
      let alternatives;
      let electedAlternative;

      if (this.state.sentenceFocused && this.state.sentenceMap[this.state.sentenceFocused].alternatives){
        let altHash = this.state.sentenceMap[this.state.sentenceFocused].alternatives;
        electedAlternative = this.electedAlternative(altHash);

        alternatives = Object.keys(altHash);
      }; //STINT replace with sentenceMap lookup

      let currentAuthorsPref = this.currentAuthorsPref();
      console.log(alternatives);

      return (
        <div class="edit-pane-wrapper">
          <div class="modalRoot" onClick={()=>{this.exitEditPane()}}></div>
          <div className="edit-pane">


            { ((this.state.mode === globals.mode.CHOOSE) || (this.state.mode === globals.mode.EDIT)) &&
              (alternatives && alternatives.length > 0) &&

              <div className="edit-pane-selection">

                <div id="alternativeSelect">
                  <table className="alternativesListed">


                    {alternatives.map((alternative) => (

                      <tr className="alternativeOption" onClick={()=> this.handleAlternativeSelection(alternative)}
                        key={alternative}>
                        <td className="voteCheckMark">
                          <div id="checkMarkWrapper">
                            {(currentAuthorsPref===alternative) &&
                              <span>&#10004;</span>
                            }
                          </div>
                        </td>
                        <td className="voteCounter">
                          <div className={(electedAlternative === alternative) ? 'alternativeVoteCount elected ' : 'alternativeVoteCount '}>
                            {Object.keys(this.state.sentenceMap[this.state.sentenceFocused].alternatives[alternative]).length}
                          </div>
                        </td>
                        <td className="alternativeContent">
                          <div className="alternativeAndComment">
                            {/* The Alternative Wording */ }

                            <span className={(electedAlternative === alternative) ? 'alternativeText elected ' : 'alternativeText '}>
                              <SanitizedHTML
                                //allowedAttributes={{ 'a': ['href'] }}
                                allowedTags={['a','b','i','u','em','strong']}
                                html={this.state.sentenceMap[alternative].text}
                              />
                            </span>

                            <span className="alternativeAuthor">
                              <FontAwesomeIcon icon={faUser} />

                              {this.props.authorDisplayNames[this.state.sentenceMap[alternative].author] || "Unknown Author" }
                            </span>

                            {/* Comments */ }
                            { this.state.sentenceMap[alternative].comments &&
                              this.state.sentenceMap[alternative].comments.map((comment) => (
                                <span key={comment} className="commentBox">
                                  <FontAwesomeIcon icon={faComment} />
                                  <span className="commentText">{this.state.commentMap[comment].text}</span>
                                </span>
                              ))
                            }
                          </div>
                        </td>
                        <td className="alternativeControls">
                          { /* Delete Mark */ }
                          { (this.state.sentenceMap[alternative].author === this.props.currentAuthor) &&
                            <span className="deleteMark" onClick={()=>this.handleDeleteAlternative(alternative)}>
                              &times;

                            </span>
                          }
                        </td>

                      </tr>

                    ))}

                    <tr className="alternativeOption editForm" >
                      <td></td>
                      <td></td>
                      <td>
                        { (this.state.mode === globals.mode.CHOOSE) &&
                          <button onClick={()=> this.handleAlternativeSelection('@@ProposeAlt') }>
                            Propose an Alternative Wording...
                          </button>
                        }
                        { ((this.state.mode === globals.mode.EDIT)) &&
                          <div className="">
                            <form onSubmit={(e)=>this.handleSubmit(e)}>

                              <label>
                                Your modified wording:
                              </label>
                              <TextareaAutosize
                                className="sentenceTextInput"
                                name="sentenceText"
                                value={this.state.sentenceText}
                                onChange={(e)=>this.handleInputChange(e)}
                                onKeyDown={(e)=>this.handleEnter(e)}
                                ref={this.editSentenceField}
                              />
                              <label>
                                (Optional) Add a comment to explain why you believe this wording is better:
                              </label>
                              <TextareaAutosize
                                className="commentTextInput"
                                name="commentText"
                                placeholder="Your comment"
                                value={this.state.commentText}
                                onChange={(e)=>this.handleCommentChange(e)}
                                onKeyDown={(e)=>this.handleEnter(e)}
                              />

                            </form>
                          </div>
                        }
                      </td>
                      <td></td>
                    </tr>
                  </table>


                </div>


              </div>
            }
          </div>
        </div>
      )

    }
    else {
      return null;
    }
  }

  author_list(){
    return (
      <div>
        <FontAwesomeIcon icon={faUsers} />&nbsp;

        <strong>Co-Authors:</strong>&nbsp;
        { this.state.authors.map(author => (
          <div class="authorName"><FontAwesomeIcon icon={faUser} />&nbsp;
            {(this.props.authorDisplayNames[author] || "Unknown Author")}</div>
        )) }
      </div>
    );
  }


  render() {
    //alert(this.props.boogers);
    if (!this.props.currentAuthor) { return null; }

    console.log("this props selected Writing");
    console.log(this.props.selectedWriting);



    return (
      <div>

        <div className="internal-frame">

          <div className="writing">
            <div className="writing-internal">
              <p>{ this.displaySentence('TITLE', true) }</p>

            </div>
          </div>

          <div className="writing-footer">
            <div id="subfooter-1">
              <div id="writing-link-wrapper" onClick={(e)=>{this.writingLinkInput.current.select();}}>
                <div>
                  <FontAwesomeIcon icon={faShareAltSquare} />&nbsp;
                  Share this link to enable collaborators to edit:
                </div>
                <input type="text" readOnly ref={this.writingLinkInput}
                  value={this.root_url() + this.props.selectedWriting}
                />
              </div>

              <span id="delete-writing" onClick={()=>this.props.handleDeleteWriting(this.props.selectedWriting)}>
                <FontAwesomeIcon icon={faUnlink} />&nbsp;
                Remove Document
              </span>
            </div>
            <div id='subfooter-2'>

              {this.author_list()}
              <br/>
            </div>

          </div>


        </div>
        <div id="help-info">
          <HowToUse/>
        </div>

      </div>


    )
  }
}
export default Writing;
